import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Deine Handynummer',
      placeholder: 'Handynummer eingeben',
    },
    email: {
      label: 'Deine E-Mail-Adresse',
      placeholder: 'E-Mail-Adresse eingeben',
    },
  },
  channel_chooser: {
    title: 'Code senden per',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Kostenlos & schnell',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'Klassische Textnachricht',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'E-Mail',
      subtitle: 'Code direkt in dein Postfach',
    },
  },
  otp: {
    title: 'Bestätigungscode eingeben',
    send_code: 'Code senden',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Per <strong>WhatsApp</strong> an <strong>{{phone}}</strong> gesendet',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Per <strong>SMS</strong> an <strong>{{phone}}</strong> gesendet',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Per <strong>E-Mail</strong> an <strong>{{phone}}</strong> gesendet',
    },
    sent_to: 'Gesendet an',
    resend: {
      title: 'Code nicht erhalten?',
      countdown: 'Erneut senden in',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: 'Code nicht per E-Mail erhalten?',
          button: 'Erneut per E-Mail senden',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: 'Nicht den Code erhalten?',
          button: 'Erneut per SMS senden',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: 'Nicht den Code erhalten?',
          button: 'Erneut per WhatsApp senden',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Stattdessen per SMS senden',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Stattdessen per WhatsApp senden',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'Es wurde eine Nachricht mit einem Verifizierungscode an dein Telefon gesendet. Gib den Code ein, um fortzufahren.',
      [OTP_DELIVERY_CHANNELS.EMAIL]:
        'Bitte gib den 4-stelligen Code ein, der an diese Adresse gesendet wurde: <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'Wir haben dir eine WhatsApp-Nachricht mit einem Verifizierungscode geschickt. Gib den Code ein, um fortzufahren.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Tipp: Überprüfe deinen Posteingang und deinen Spam-Ordner.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Hinweis — der Code wird von <strong>{{sender}}</strong>, unserem Technologiepartner, gesendet.',
    business_account: 'Unternehmenskonto',
    message:
      '<strong>123456</strong> ist dein Bestätigungscode. Teile diesen Code aus Sicherheitsgründen mit niemandem.',
  },
  error_messages: {
    frequent_requests:
      'Bitte prüfe deine Nachrichten. Wir haben den Code bereits an die angegebene Nummer gesendet. Wenn nicht, prüfe bitte die Telefonnummer oder versuche es in 10 Minuten erneut.',
    frequent_requests_email:
      'Bitte prüfe deinen Posteingang und deinen Spam-Ordner. Wir haben den Code bereits an diese Adresse gesendet. Falls er nicht angekommen ist, versuche es in 10 Minuten erneut.',
    invalid_number: 'Ungültige Telefonnummer. Bitte versuche es erneut.',
    invalid_email: 'Wir konnten den Code nicht an diese E-Mail-Adresse senden. Bitte prüfe sie und versuche es erneut.',
    email_not_on_file:
      'Zu dieser Handynummer gibt es bereits ein Konto ohne E-Mail-Adresse. Bitte wende dich an {{support_email}}, um eine hinzuzufügen — bis dahin können wir Codes für diese Nummer nicht per E-Mail senden.',
    turnstile_required: 'Bitte schließe die Verifizierung ab, bevor du einen neuen Code anforderst.',
    generic_error: 'Hoppla, da ist etwas schiefgelaufen. Bitte aktualisiere die Seite und versuche es erneut.',
    change_phone_number_unsuccessful: 'Änderung der Telefonnummer fehlgeschlagen. Bitte versuche es erneut.',
  },
  toasts: {
    code_sent: 'Code gesendet',
  },
};
